import React, { Component } from 'react';
import Draggable from 'react-draggable';

//styles and icons
import { Row, Col } from 'react-bootstrap';
import  { FormControl , Select , InputLabel } from '@material-ui/core';
import FormatAlignLeftIcon from '@material-ui/icons/FormatAlignLeft';
import FormatAlignCenterIcon from '@material-ui/icons/FormatAlignCenter';
import FormatAlignRightIcon from '@material-ui/icons/FormatAlignRight';
import FormatItalicIcon from '@material-ui/icons/FormatItalic';
import FormatBoldIcon from '@material-ui/icons/FormatBold';
import SaveChanges from './addons-save.component';
import './addons.style.css';


// this component represents the text-editor addon of the video recorder

export default class TextEditor extends Component {

    constructor() {
        super();
        this.state = [];
    }
    // ****** handle text editor ******
    handleAlignLeft = () => {

        document.querySelector('#text-input').classList.toggle('text-left');
        document.querySelector('.text-editor-left').classList.toggle('text-orange');

        document.querySelector('#text-input').classList.remove('text-right');
        document.querySelector('.text-editor-right').classList.remove('text-orange');
        document.querySelector('#text-input').classList.remove('text-center');
        document.querySelector('.text-editor-center').classList.remove('text-orange');
    }
    showAlignLeft = () => {
        document.querySelector('#text-input').classList.add('text-left');
        document.querySelector('.text-editor-left').classList.add('text-orange');

        document.querySelector('#text-input').classList.remove('text-right');
        document.querySelector('.text-editor-right').classList.remove('text-orange');
        document.querySelector('#text-input').classList.remove('text-center');
        document.querySelector('.text-editor-center').classList.remove('text-orange');
    }
    handleAlignRight = () => {
        document.querySelector('#text-input').classList.toggle('text-right');
        document.querySelector('.text-editor-right').classList.toggle('text-orange');

        document.querySelector('#text-input').classList.remove('text-left');
        document.querySelector('.text-editor-left').classList.remove('text-orange');
        document.querySelector('#text-input').classList.remove('text-center');
        document.querySelector('.text-editor-center').classList.remove('text-orange');
    }
    showAlignRight = () => {
        document.querySelector('#text-input').classList.add('text-right');
        document.querySelector('.text-editor-right').classList.add('text-orange');

        document.querySelector('#text-input').classList.remove('text-left');
        document.querySelector('.text-editor-left').classList.remove('text-orange');
        document.querySelector('#text-input').classList.remove('text-center');
        document.querySelector('.text-editor-center').classList.remove('text-orange');
    }
    handleAlignCenter = () => {
        document.querySelector('#text-input').classList.toggle('text-center');
        document.querySelector('.text-editor-center').classList.toggle('text-orange');

        document.querySelector('#text-input').classList.remove('text-right');
        document.querySelector('.text-editor-right').classList.remove('text-orange');
        document.querySelector('#text-input').classList.remove('text-left');
        document.querySelector('.text-editor-left').classList.remove('text-orange');
    }
    showAlignCenter = () => {
        document.querySelector('#text-input').classList.add('text-center');
        document.querySelector('.text-editor-center').classList.add('text-orange');

        document.querySelector('#text-input').classList.remove('text-right');
        document.querySelector('.text-editor-right').classList.remove('text-orange');
        document.querySelector('#text-input').classList.remove('text-left');
        document.querySelector('.text-editor-left').classList.remove('text-orange');
    }
    handleItalic = () => {
        document.querySelector('#text-input').classList.toggle('font-italic');
        document.querySelector('.text-editor-italic').classList.toggle('text-orange');
    }
    showItalic = () => {
        document.querySelector('#text-input').classList.add('font-italic');
        document.querySelector('.text-editor-italic').classList.add('text-orange');
    }
    handleBold = () => {
        document.querySelector('#text-input').classList.toggle('font-weight-bold');
        document.querySelector('.text-editor-bold').classList.toggle('text-orange');
    }
    showBold = () => {
        document.querySelector('#text-input').classList.add('font-weight-bold');
        document.querySelector('.text-editor-bold').classList.add('text-orange');
    }
    handleTextColor = (e, value = e.target.value) => {
        let ChosenColor = value;
        document.querySelector('.text-color-icon').style.color = ChosenColor;
        document.querySelector('#text-input').style.color = ChosenColor;
    }
    handleBgColor = (e, value = e.target.value) => {
        let ChosenColor = value;
        document.querySelector('.bg-color-icon').style.color = ChosenColor;
        document.querySelector('#text-input').style.backgroundColor = ChosenColor;
    }
    handleFontSize = (e , value = e.target.value) => {
        document.querySelector('.font-size .MuiSelect-select').value = value;
        document.querySelector('#text-input').style.fontSize = value+'px';
    }

    // ****** handle save and view data ******
    callback = (data) => {
        if (data === 'save') {
            this.saveData();
            this.handleOnclick();
            this.hideAddonsBtns()

        } else if (data === 'clear') {
            this.handleOnclick();
            this.hideAddonsBtns()
            this.viewText = null;
            this.props.callbackFromParent(0, "remove flag");
        }
    }
    handleOnclick = () => {
        setTimeout(function() {
            document.querySelector('#text-input').focus();
          }, 200);
        // hide img editor
        this.closeImgEditor();
        // delete show value
        this.viewText = null;
        document.querySelector('.text-editor-container').classList.toggle('d-none');
        document.querySelector('.text-input-container').classList.toggle('d-none');

        this.resetData();
    }
    handleChangeInput = (e) => {
        document.querySelector('.addon-text .saveChanges').classList.remove('d-none');
        if (e.target.value.length < 1) {
            document.querySelector('.addon-text .saveChanges').classList.add('d-none');
        }
    }
    resetData = () => {
        // hide save changes buttons
        document.querySelector('.addon-text .saveChanges').classList.add('d-none');
        // reset all class
        let btns = document.querySelectorAll('.text-editor-btn');
        for (let i = 0; i < btns.length; i++) {
            btns[i].classList.remove('text-orange');
        }
        //reset font color
        document.querySelector('.text-color-icon').style.color = "white";
        document.querySelector('#text-input').style.color = 'white';

        // reset background color 
        document.querySelector('.bg-color-icon').style.color = 'white';
        document.querySelector('#text-input').style.backgroundColor = '#040404ba';

        // reset font size 
        document.querySelector('.font-size .MuiSelect-select').selectedIndex = 0;
        document.querySelector('#text-input').style.fontSize = '12px';
        // reset positions 
        document.querySelector(".addon-text  .p-relative").style.transform = 'translate(250px,350px)';

        document.querySelector("#text-input").value = "";
        document.querySelector("#text-input").classList = "";
    }
    rgbToHex = (rgb) => {
        let a = 'ff';
        if (rgb === 'white') {
            rgb = 'rgb(255,255,255)'
        } else if (rgb === 'rgba(4, 4, 4, 0.73)') {
            rgb = 'rgb(4, 4, 4)';
            a = 'ba'
        }
        // Choose correct separator
        let sep = rgb.indexOf(",") > -1 ? "," : " ";
        // Turn "rgb(r,g,b)" into [r,g,b]
        rgb = rgb.substr(4).split(")")[0].split(sep);

        let r = (+rgb[0]).toString(16),
            g = (+rgb[1]).toString(16),
            b = (+rgb[2]).toString(16);
        if (r.length == 1)
            r = "0" + r;
        if (g.length == 1)
            g = "0" + g;
        if (b.length == 1)
            b = "0" + b;

        return "#" + r + g + b + a;
    };
    saveData = () => {
        // hide save changes buttons
        document.querySelector('.addon-text .saveChanges').classList.add('d-none');
        let element = document.querySelector("#text-input");
        // let elementRelative = document.querySelector('.video-addons-container');
        let position_x = 0, position_y = 0;
        let dragedElement = document.querySelector(".addon-text  .p-relative").style.transform;

        let textValue = element.value;
        let startTime = this.startTime
        let finishTime = startTime + 4;
        let classes = element.classList;
        let textAlign = 'left', TextStyle = 'normal', TextWeight = 'normal';
        let fontColor = element.style.color;
        let bgColor = element.style.backgroundColor;
        let textSize = parseInt(element.style.fontSize.replace('px',''));
        let width = parseInt(element.getBoundingClientRect().width);
        let height = parseInt(element.getBoundingClientRect().height);
        // convert colors from  rgb to hex
        fontColor = this.rgbToHex(fontColor);
        bgColor = this.rgbToHex(bgColor);

        // get x and y position of text
        position_x = parseInt(dragedElement.split('(').pop().split('px')[0]);
        position_y = parseInt(dragedElement.split(',').pop().split('px')[0]);
        // console.log(dragedElement)
        // while (dragedElement && dragedElement !== elementRelative && !isNaN(dragedElement.offsetLeft) && !isNaN(dragedElement.offsetTop)) {
        //     position_x += dragedElement.offsetLeft - dragedElement.scrollLeft + dragedElement.clientLeft;
        //     position_y += dragedElement.offsetTop - dragedElement.scrollTop + dragedElement.clientTop;
        //     dragedElement = dragedElement.offsetParent;
        //     console.log(position_y ,position_x)
        // }

        // get styles
        for (let i = 0; i < classes.length; i++) {
            if (classes[i] === 'text-left') textAlign = 'left';
            else if (classes[i] === 'text-right') textAlign = 'right';
            else if (classes[i] === 'text-center') textAlign = 'center';
            else textAlign = 'left';

            if (classes[i] === 'font-italic') TextStyle = 'italic'
            else TextStyle = 'normal'
            if (classes[i] === 'font-weight-bold') TextWeight = 'bold'
            else TextWeight = 'normal'
        }
        // set all styles in textAddonsInput variable
        let textAddonInput = {
            start_time: startTime, finish_time: finishTime,
            text: textValue, position_x: position_x, position_y: position_y,
            text_align: textAlign, text_weight: TextWeight,
            text_style: TextStyle, text_size: textSize,
            padding_top: 15, padding_bottom: 10,
            padding_left: 6, padding_right: 6,
            width: width, height: height, text_color: fontColor,
            background_color: bgColor
        }
        // send data to parent using callback function
        if (textAddonInput) {
            if (!this.viewText) {
                this.props.callbackFromParent(textAddonInput, "add");
            } else {
                this.props.callbackFromParent(textAddonInput, "edit");
            }
        }

        // reset data 
        this.resetData();
    }
    closeImgEditor = () => {
        document.querySelectorAll('.img-output-container').forEach(e => e.classList.add('d-none'));
        document.querySelector('.addon-images .saveChanges').classList.add('d-none');

    }
    showData = (textInfo) => {
        // close img editor if open
        this.closeImgEditor();
        // open text editor
        document.querySelector('.text-editor-container').classList.remove('d-none');
        document.querySelector('.text-input-container').classList.remove('d-none');
        // show save changes btns
        document.querySelector('.addon-text .saveChanges').classList.remove('d-none');
        // reset place of input 
        document.querySelector(".addon-text  .p-relative").style.transform = `translate(${textInfo.position_x}px,${textInfo.position_y}px)`;
        // set the value in text area .
        document.querySelector("#text-input").value = textInfo.text;
        // set alignments 
        switch (textInfo.text_align) {
            case "center":
                this.showAlignCenter()
                break;
            case "left":
                this.showAlignLeft()
                break;
            case "right":
                this.showAlignRight()
                break;
            default:
                this.showAlignLeft()
                break;
        }
        // set styles colors and font size
        if (textInfo.text_style === "italic") {
            this.showItalic();
        }
        if (textInfo.text_weight === "bold") {
            this.showBold();
        }
        if (textInfo.text_color) {
            this.handleTextColor("e", textInfo.text_color);
        }
        if (textInfo.background_color) {
            this.handleBgColor("e", textInfo.background_color)
        }
        if (textInfo.text_size) {
            this.handleFontSize("e", textInfo.text_size)
        }
    }
    hideAddonsBtns = () => {
        document.querySelector('.addonTextAndImage').classList.add('d-none');

        let flagBtn = document.querySelector('#FlagBtn');
        flagBtn.classList.remove("bg-orange");
    }
    viewText = null;
    startTime = 0;
    componentWillReceiveProps(props) {
        if (props !== this.props) {
            if (props.viewText) {
                this.showData(props.viewText);
                this.viewText = props.viewText
                if (props.startTime) {
                    this.startTime = props.startTime
                }
            }
            else if (props.startTime) {
                this.startTime = props.startTime
            }
            else {
                // hide text editor
                document.querySelector('.text-editor-container').classList.add('d-none');
                document.querySelector('.text-input-container').classList.add('d-none');
                this.resetData();
            }
        }
    }
    render() {
        return (
            <div className="addon-text">
                <div
                    className="p-absolute w-100 text-left "
                    style={{ top: '4rem', right: '1rem' }}
                >
                    <Row className="row m-0 justify-content-end">
                        <Col xs={7} className="p-0 d-none text-editor-container text-center">
                            <div className="bg-dark-transperant">
                                <div className="d-inline-block">
                                    <FormControl className="font-size" style={{verticalAlign : 'baseline'}}>
                                        <Select
                                            native
                                            value={this.state.font}
                                            onChange={this.handleFontSize}
                                        >
                                            <option value={12}>12</option>
                                            <option value={14}>14</option>
                                            <option value={16}>16</option>
                                            <option value={18}>18</option>
                                            <option value={20}>20</option>
                                            <option value={24}>24</option>
                                            <option value={26}>26</option>
                                            <option value={28}>28</option>
                                            <option value={36}>36</option>
                                        </Select>
                                    </FormControl>
                                </div>
                                <button
                                    className="text-editor-btn text-editor-left border-0 bg-transparent text-white p-2 text-center"
                                    onClick={this.handleAlignLeft}
                                >
                                    <FormatAlignLeftIcon className="icon-responsive" />
                                </button>
                                <button
                                    className="text-editor-btn text-editor-center border-0 bg-transparent text-white p-2 text-center"
                                    onClick={this.handleAlignCenter}
                                >
                                    <FormatAlignCenterIcon className="icon-responsive" />
                                </button>
                                <button
                                    className="text-editor-btn text-editor-right border-0 bg-transparent text-white p-2 text-center"
                                    onClick={this.handleAlignRight}
                                >
                                    <FormatAlignRightIcon className="icon-responsive" />
                                </button>
                                <button
                                    className="text-editor-btn text-editor-italic border-0 bg-transparent text-white p-2 text-center"
                                    onClick={this.handleItalic}
                                >
                                    <FormatItalicIcon className="icon-responsive" />
                                </button>
                                <button
                                    className="text-editor-btn text-editor-bold border-0 bg-transparent text-white p-2 text-center"
                                    onClick={this.handleBold}
                                >
                                    <FormatBoldIcon className="icon-responsive" />
                                </button>
                                <div className="d-inline-block">
                                    <label
                                        for="text-color"
                                        id=''
                                        style={{ height: '3rem', width: '3rem', fontSize: '1.2rem', cursor: "pointer" }}
                                        className="text-editor-btn text-editor-bold border-0 bg-transparent text-white p-2 text-center"
                                    >
                                        <svg className="MuiSvgIcon-root icon-responsive  " focusable="false" viewBox="0 0 24 24" aria-hidden="true" role="presentation" style={{ color: 'white' }}>
                                            <path className="text-color-icon" fill-opacity=".36" d="M0 20h24v4H0z"></path>
                                            <path d="M11 3L5.5 17h2.25l1.12-3h6.25l1.12 3h2.25L13 3h-2zm-1.38 9L12 5.67 14.38 12H9.62z"></path>
                                        </svg>
                                    </label>
                                    <input
                                        id="text-color"
                                        type="color"
                                        className="d-none"
                                        onChange={this.handleTextColor}
                                    />
                                </div>
                                <div className="d-inline-block">
                                    <label
                                        for="bg-color"
                                        id=''
                                        style={{ height: '3rem', width: '3rem', fontSize: '1.2rem', cursor: "pointer" }}
                                        className="text-editor-btn text-editor-bold border-0 bg-transparent text-white p-2 text-center"
                                    >
                                        <svg className="MuiSvgIcon-root icon-responsive" focusable="false" viewBox="0 0 24 24" aria-hidden="true" role="presentation" style={{ color: 'white' }}>
                                            <path d="M16.56 8.94L7.62 0 6.21 1.41l2.38 2.38-5.15 5.15c-.59.59-.59 1.54 0 2.12l5.5 5.5c.29.29.68.44 1.06.44s.77-.15 1.06-.44l5.5-5.5c.59-.58.59-1.53 0-2.12zM5.21 10L10 5.21 14.79 10H5.21zM19 11.5s-2 2.17-2 3.5c0 1.1.9 2 2 2s2-.9 2-2c0-1.33-2-3.5-2-3.5z"></path>
                                            <path className="bg-color-icon" fill-opacity=".36" d="M0 20h24v4H0z"></path>
                                        </svg>
                                    </label>
                                    <input
                                        id="bg-color"
                                        type="color"
                                        className="d-none"
                                        onChange={this.handleBgColor}
                                    />
                                </div>   
                            </div>
                        </Col>
                        <Col xl={1} md={2} xs={3} className="text-right p-0">
                            <button
                                id='TextEditorBtn'
                                style={{ height: '3rem', width: '3rem', fontSize: '1.2rem' }}
                                className="rounded-circle bg-dark-transperant p-2 border-0 text-white icon-responsive"
                                onClick={this.handleOnclick}
                            > Aa
                            </button>
                        </Col>
                    </Row>
                </div>
                <div
                    className="p-absolute  d-none text-input-container"
                    style={{ top: '0rem' , cursor : 'move'}}>
                    <Draggable
                        bounds=".video-addons-container"
                        onStop={this.handleStop}
                        defaultPosition={{ x: 250, y: 350 }}
                    >
                        <div
                            className="h-100  p-relative"
                            style={{ height: '5rem' }}
                        >
                            <button
                                type="button"
                                className="close p-absolute"
                                aria-label="Close"
                                style={{ top: '-9px', left: '-5px', zIndex: '1' }}
                                onClick={this.handleOnclick}
                            >
                                <span aria-hidden="true">&times;</span>
                            </button>
                            <input
                                autofocus 
                                id="text-input"
                                type="text"
                                className="addon-textarea"
                                style={{ padding: '15px 10px 10px 10px' }}
                                maxLength="30"
                                onChange={this.handleChangeInput}
                            />
                        </div>
                    </Draggable>
                </div>
                <SaveChanges callbackFromParent={this.callback} />
            </div>
        )
    }
}